export default __webpack_public_path__ + "static/media/location.89c4bf9e.svg";